import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export type CriaUsuarioTenantPayload = {
  nome: string
  email: string
  papelOrganizacao: PapelOrganizacaoType
  senha: string
  senhaConfirmacao: string
  // VENDEDOR: um CPF. COORDENADOR/ASSISTENTE: a lista cpfcnpjs (PD-0004).
  cpfcnpj?: string
  cpfcnpjs?: string[]
}

export const getUsers = async (
  query: string,
  tenantId: string,
  page: number
): Promise<GetUsersType | { message: string }> => {
  try {
    const result = await apiService.get(
      `central/usuario/organizacao/${tenantId}`,
      {
        params: {
          query,
          tenantId,
          page: page - 1,
          size: 7,
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getUsuariosTenantFiltro = async (
  tenantId: string
): Promise<UsuarioFiltroType[]> => {
  try {
    const result = await apiService.get(
      `central/usuario/organizacao/${tenantId}/filtro`
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    // em caso de falha o filtro de usuário fica vazio; demais filtros seguem normais
  }
  return []
}

export const getUsersOrgId = async (
  tenantId: string,
  usuarioId: number
): Promise<GetUsersOrgIdType | { message: string }> => {
  try {
    const result = await apiService.get(
      `central/usuario/organizacao/${tenantId}/${usuarioId}`
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const putUsersOrgIdEdit = async (
  tenantId: string,
  usuarioId: number,
  organizacaoEditRequestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(
      `central/usuario/organizacao/${tenantId}/${usuarioId}`,
      {
        ...organizacaoEditRequestDTO,
      }
    )
    if (result.status === 200) {
      return { info: 'Usuário editado com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getExisteEmailTenant = async (
  tenantId: string,
  email: string
): Promise<boolean> => {
  try {
    const result = await apiService.get(
      `central/usuario/organizacao/${tenantId}/existe-email`,
      { params: { email } }
    )
    if (result.status === 200) {
      return result.data === true
    }
  } catch (error) {
    // em caso de falha assume inexistente: cai no fluxo de criação com senha
  }
  return false
}

export const postCriaUsuarioTenant = async (
  tenantId: string,
  payload: CriaUsuarioTenantPayload
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `central/usuario/organizacao/${tenantId}`,
      { ...payload }
    )
    if (result.status === 200 || result.status === 201) {
      return { info: 'Usuário criado com sucesso!' }
    }
  } catch (error) {
    // a API devolve regras de negócio como [{ msgUsuario, msgDesenvolvedor }] em 400;
    // mostra a msgUsuario quando houver, senão cai no tratamento genérico por status
    if (axios.isAxiosError(error)) {
      const data = error.response?.data
      const msg = Array.isArray(data) ? data[0]?.msgUsuario : undefined
      if (msg) {
        return { message: msg }
      }
    }
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchAtivaDesativaUsuarioOrganizacao = async (
  id: number,
  tenantId: string,
  acao: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(
      `central/usuario/organizacao/${acao}/${tenantId}/${id}`
    )
    if (result.status === 200) {
      return acao === 'ativar'
        ? { info: 'Usuário ativado!' }
        : { info: 'Usuário desativado!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
